const i18n = {
  'zh-CN': {
    therequestfailed: '请求失败',
    backMall: '导入/导出',
    currentlist: '将为您导出当前列表的全部数据',
    currentFilter: '将为您导出当前筛选结果的全部数据',
    tip: '提示',
    confirm: '确定',
    cancel: '取消',
    deleteInformation: '确定删除信息吗?',
    successfullyDelete: '删除成功',
    selectedInformation: '确定删除所选信息吗?',
    loading: '加载中',
    operateSuccessfully: '操作成功',
    personCharge: '请选择负责人',
    confirmAddress: '请求地址错误,请确认地址!',
    operation: '操作',
    SelectLeastOnePieceOfData: '请选择数据',
    VerifyFailed: '校验未通过',
    auxiliary: '第',
    page: '页',
    ErrorCheckingBarData: '条数据校验错误.',
    FromRequired: '从对象必填',
    MaximumSupportForAddition: '最多支持添加',
    lineDetail: '行明细',
    silently: '您无【',
    pleaseContactAdministrator: '】对象的【查看列表】或【新建/编辑】权限，请联系管理员'
  },
  'en': {
    therequestfailed: 'Request failed',
    backMall: 'Import/Export',
    currentlist: 'All the data of the current list will be exported for you',
    currentFilter: 'All the data of the current filtered result will be exported for you',
    tip: 'Tips',
    confirm: 'Confirm',
    cancel: 'Cancel',
    deleteInformation: 'Confirm to delete the information?',
    successfullyDelete: 'Deleted successfully',
    selectedInformation: 'Confirm to delete the selected information?',
    loading: 'Loading',
    operateSuccessfully: 'Operation succeeded',
    personCharge: 'Please select the person in charge',
    confirmAddress: 'Incorrect address requested. Please confirm the address!',
    operation: 'Operation',
    SelectLeastOnePieceOfData: 'Select at least one piece of data',
    VerifyFailed: 'Verification Failed ',
    auxiliary: 'The ',
    page: 'page',
    ErrorCheckingBarData: 'Data validation error',
    FromRequired: 'Subsequent object is required',
    MaximumSupportForAddition: 'Support up to add',
    lineDetail: 'Line detail',
    silently: 'You have no [',
    pleaseContactAdministrator: '】对象的【查看列表】或【新建/编辑】权限，请联系管理员'
  }
}

export default window.fe.getPageText(i18n)
